import { render, staticRenderFns } from "./HeaderTabs.vue?vue&type=template&id=8f6d2ca2&scoped=true&"
import script from "./HeaderTabs.vue?vue&type=script&lang=js&"
export * from "./HeaderTabs.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTabs.vue?vue&type=style&index=0&id=8f6d2ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6d2ca2",
  null
  
)

export default component.exports